import uniqid from 'uniqid'
import { workExperience } from '../../portfolio'
import './WorkExperience.css'

const WorkExperience = () => {
  if (!workExperience.length) return null

  return (
    <section className='section skills' id='workExperience'>
      <h2 className='section__title'>Work Experience</h2>
      {workExperience.map((e) => (
          <div className="main-container">
              <div className="item-container">
                <div className="title-container">
                    <a href={e.site}>
                        <p className="job-title">{e.title}</p>
                    </a>
                    <p className="job-date">{e.date}</p>
                </div>
                <div className="title-container">
                    <p className="job-position">{e.position}</p>
                    <p className="job-location">{e.location}</p>
                </div>
                <div className="desc-container">
                    {e.description}
                </div>
                <div className="tasks-container">
                    {
                        e.tasks.map((task) =>
                            <div className="task-container">
                                <span className="circle">
                                    <></>
                                 </span>
                                <p>
                                    {task}
                                </p>
                            </div>
                        )
                    }
                </div>
              </div>
          </div>
        ))}

    </section>
  )
}

export default WorkExperience
